import classNames from 'classnames'

interface SelectProps {
  text: string
  onClick: () => void
}

export default function Select({ text, onClick }: SelectProps) {
  const selectClass = classNames(
    'rounded-md',
    'p-4',
    'w-full',
    'bg-white',
    'hover:bg-blue-800',
    'hover:text-white',
    'cursor-pointer',
    'text-center',
  )
  return (
    <div className={selectClass} onClick={onClick}>
      {text}
    </div>
  )
}
